import styled from 'styled-components';
import React, { useState } from 'react'
import RegisterBox from './RegisterBox'

function RegisterBtn() {
  const [openRegister, setOpenRegister] = useState(false)
  
  return (
    <RegisterBtnContainer>
      <Register_Btn onClick={()=>{
        setOpenRegister(true)
      }}>Register Now</Register_Btn>

      {openRegister && <RegisterBox closeRegisterBox={setOpenRegister} />}
      
    </RegisterBtnContainer>
  )
}

export default RegisterBtn
const Register_Btn = styled.button` 

background:#fa7525 ;
border:none ;
border-radius:5px ;
padding:10px 20px 10px 20px ;
 &:hover{
   background-color:black ;
   color:#fa7525 ;
 }
`
const RegisterBtnContainer = styled.div` 
display: flex;
justify-content: end;
align-items:center ;
z-index:9 ;
`